import styled, { css } from "styled-components";
import { color, highContrastStyle, onHover, units } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
export const IconButton = styled(NakedButton) `
  // Safari fix for outline
  transform: translateZ(0);
  display: inline-block;
  padding: 0;
  user-select: none;

  transition: color 0.2s ease-in;
  color: ${color("base")};

  ${({ activeColorScheme }) => activeColorScheme === "alchemyBrand"
    ? css `
          opacity: ${highContrastStyle("1", "0.85")};
        `
    : css ``}

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    color: currentColor;
  }

  ${({ activeColorScheme }) => activeColorScheme === "alchemyBrand"
    ? onHover(css `
          opacity: 1;
        `)
    : onHover(css `
          color: ${color("base", { palette: "interactiveConstructive" })};
        `)}

  // Override the default focus styles coming from onHover
  ${({ activeColorScheme }) => {
    if (activeColorScheme === "alchemyBrand") {
        return css `
        &:enabled:focus {
          opacity: 1;
          svg {
            color: ${color("base")};
          }
        }
      `;
    }
    return css ``;
}}
      

  ${onHover(css `
    @media (forced-colors) {
      outline: 1px solid Highlight;
    }
  `)}

  &:disabled, &[aria-disabled="true"] {
    cursor: not-allowed;

    svg {
      opacity: 0.5;
    }

    @media (forced-colors) {
      svg {
        opacity: 1;
      }

      // CSS color for disabled buttons in forced colors mode
      color: GrayText;
    }
  }
`;
export const DisabledButtonWrapper = styled.div `
  display: inline-flex;
`;
export const IconButtonTriggerWrapper = styled.div `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: transparent;
  padding: ${units(0.5)};
  transition: all ease-in 0.1s;
  border-radius: 50%;

  transition-property: all;
  animation-timing-function: cubic-bezier(0, 0, 1, 1);
  animation-duration: 0.1s;

  ${onHover(css `
    svg {
      color: ${color("base", { palette: "interactiveConstructive" })};
    }
    cursor: pointer;
  `)}
`;
